export const forceReload = () => document.location.reload();
